module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie TagInput component is a text input where we can add different values as\ntags.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;TagInput label=&quot;Categories&quot;&gt;\n    &lt;Tag&gt;Category 1&lt;/Tag&gt;\n    &lt;Tag&gt;Category 2&lt;/Tag&gt;\n&lt;/TagInput&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TagInput/README.md
// module id = 400
// module chunks = 0